
import React from 'react';

const AlterSuccess = () => {
    return (
        <div class="alert alert-success text-center my-alert" role="alert">
            <p>You have successfully voted in the poll. You will be logged out in 5 seconds</p>
        </div>
    );
}

export default AlterSuccess;